/* eslint-disable no-case-declarations */

import {
  LOADING_ADDRESSDBS,
  LOADING_ADDRESSDBS_SUCCESS,
  LOADING_ADDRESSDBS_ERROR,

  ADDING_ADDRESSDB,
  ADDING_ADDRESSDB_SUCCESS,
  ADDING_ADDRESSDB_ERROR,

  UPDATING_ADDRESSDB,
  UPDATING_ADDRESSDB_SUCCESS,
  UPDATING_ADDRESSDB_ERROR,

  DELETING_ADDRESSDB,
  DELETING_ADDRESSDB_SUCCESS,
  DELETING_ADDRESSDB_ERROR,

  UPDATING_ADDRESSDB_CHECKS,
} from '../actions/addressdbs';
  
const initialState = {
  addressdbList: [],
  loading: false,
};
  
const AddressDBsReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_ADDRESSDBS:
        return { ...state, loading: true };
  
      case LOADING_ADDRESSDBS_SUCCESS:
        return {
          ...state,
          loading: false,
          addressdbList: action.payload,
        };

      case ADDING_ADDRESSDB:
        return { ...state, loading: true };
  
      case ADDING_ADDRESSDB_SUCCESS:
        return {
          ...state,
          loading: false,
          addressdbList: [...state.addressdbList, action.payload],
        };

      case UPDATING_ADDRESSDB:
        return { ...state, loading: true };
  
      case UPDATING_ADDRESSDB_SUCCESS:
        const addressdb = action.payload;
        const newAddressDBs = state.addressdbList.map((obj) => {
          return addressdb.id === obj.id ? addressdb : obj;
        });
        return {
          ...state,
          loading: false,
          addressdbList: [...newAddressDBs]
        };

      case DELETING_ADDRESSDB:
        return { ...state, loading: true };
  
      case DELETING_ADDRESSDB_SUCCESS:
        return {
          ...state,
          loading: false,
          addressdbList: [...state.addressdbList.filter((obj) => obj.id !== action.payload.id)],
        };

      default:
        return state;
    }
  };
  
  export default AddressDBsReducer;
  